import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import React from 'react';
import { GridContainer } from '../../commons/styleds/styleds';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useMenusActions } from '../../states/menus/menu.actions';
import { IArea, IMenu, ISecao } from '../../commons/types/base';
import { Box, Grid2, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import IconButton from '@mui/material/IconButton';
import type { IMenuItens } from '../../components/Header';
import { findBreadcrumb } from '../../components/Breadcrumb/findBreadcrumb';
import Breadcrumb from '../../components/Breadcrumb';
import Eventos from '../Eventos';
import { GridBackground, TypographyDesc } from '../Acoes';
import Consultor from '../Home/Components/Consultor';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function createHTMLFromString(htmlString: any) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}

interface IParams {
  id?: string;
}

const MenuComponent: React.FC = () => {
  
  const path = window.location.pathname;
  const { id } = useParams<IParams>();
  const [area, setArea] = useState<IArea>();
  const [secoes, setSecoes] = useState<ISecao[]>([]);
  const location = useLocation();
  const currentPath = location.pathname;
  const [isEvento, setIsEvento] = useState<boolean>(false);
  const [expandedDescricaoId, setExpandedDescricaoId] = useState<number | null>(null);

  const toggleDescricao = (secaoId: number, event: React.MouseEvent) => {
    event.preventDefault();
    setExpandedDescricaoId(expandedDescricaoId === secaoId ? null : secaoId);
  };

  const menusActions = useMenusActions();

  useEffect(() => {
    const loadData = async () => {
      let structure = JSON.parse(localStorage.getItem('menusDinamicos') ?? '[]') as IMenuItens[];
      const breadcrumb = findBreadcrumb(currentPath, structure);
      const indexEventos = breadcrumb!.findIndex((f: any) => f.nome === 'Eventos');
      if (indexEventos >= 0 && indexEventos < breadcrumb!.length - 1) {
        setIsEvento(true);
      } else {
        setIsEvento(false);
      }
    }
    loadData();
    menusActions
      .get()
      .then((d) => {
        let menus: IMenu = d.resultado;

        let area = menus.areas.find((f) => f.id == Number(id));
        let secoes = menus.secoes.filter((f) => f.idArea == Number(id));
        setArea(area);
        setSecoes(secoes);
      })
      .catch((erro) => {
      });
  }, [id]);

  return (
    <div>
      {isEvento
        ? <Eventos />
        :
        <GridBackground container direction="column" spacing={0} sx={{ minHeight: '90vh' }}>
          <Consultor />

          <Grid2 size={{ xs: 12 }}>
            <Breadcrumb />
          </Grid2>

          <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '30px' }}>
            <Typography variant="h1">{area?.nome}</Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '10px' }}>
            <TypographyDesc variant="body1">
              {createHTMLFromString(area?.descricao)}
            </TypographyDesc>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            {secoes.map((item: ISecao) => {
              const isExpanded = expandedDescricaoId === item.id;
              return (
                <>
                  <Grid
                    container
                    xs={12}
                    md={12}
                    sx={{
                      padding: '10px 10px',
                      display: 'flex',
                      borderBottom: 'solid 1.5px #dfdfdf',
                    }}
                  >
                    <Grid container xs={12} md={12} alignItems="center">
                      <IconButton onClick={(e) => toggleDescricao(item.id, e)} size="small">
                        {isExpanded ? (
                          <KeyboardArrowDownIcon sx={{ fontSize: '16px', color: '#551a8b' }} />
                        ) : (
                          <ArrowForwardIosIcon sx={{ fontSize: '16px', color: '#551a8b' }} />
                        )}
                      </IconButton>
                      <Link to={path + '/secoes/' + item.id} style={{ display: 'flex', alignItems: 'center' }}>
                        {item.nome}
                      </Link>
                    </Grid>

                    {item.descricao && isExpanded && (
                      <Grid
                        container
                        xs={12}
                        md={12}
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          width: '100%',
                          maxWidth: '100%',
                          overflow: 'hidden'
                        }}
                      >
                        <Box sx={{ 
                          display: 'flex', 
                          flexWrap: 'wrap', 
                          paddingLeft: '30px',
                          width: '100%',
                          maxWidth: 'calc(100% - 30px)',
                          overflowX: 'auto',
                          '& img': {
                            maxWidth: '100%',
                            height: 'auto'
                          },
                          '& table': {
                            maxWidth: '100%',
                            display: 'block',
                            overflowX: 'auto'
                          }
                        }}>
                          {createHTMLFromString(item.descricao)}
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </>
              );
            })}
          </Grid2>
        </GridBackground>
      }
    </div>
  );
};

export default MenuComponent;
